import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../AuthContext';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #c8102e 0%, #6b0017 100%)',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    borderTop: '5px solid #c8102e',
    padding: '44px 40px 40px',
    width: 380,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    textAlign: 'center',
  },
  logo: {
    fontSize: 32,
    marginBottom: 8,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: '#1a1a2e',
    marginBottom: 4,
  },
  sub: {
    fontSize: 14,
    fontWeight: 600,
    color: '#c8102e',
    letterSpacing: 0.3,
    marginBottom: 32,
  },
  error: {
    background: '#fce8e6',
    color: '#c5221f',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    marginBottom: 16,
  },
  note: {
    fontSize: 11,
    color: '#aaa',
    marginTop: 20,
  },
};

export default function LoginPage() {
  const { loginWithGoogle, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError]   = useState('');

  useEffect(() => { if (user) navigate('/'); }, [user]);

  function handleSuccess(credentialResponse) {
    const result = loginWithGoogle(credentialResponse);
    if (result.error) {
      setError(result.error);
    } else {
      navigate('/');
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img
          src="/logo-wordmark-red.svg"
          alt="Ninja Mart"
          width={40 * 1.536}
          height={40}
          style={{ height: 60, width: 60 * 1.536, objectFit: 'contain', marginBottom: 16 }}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div style={styles.sub}>Credit Management System</div>
        {error && <div style={styles.error}>{error}</div>}
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => setError('Google sign-in failed. Please try again.')}
          useOneTap
          theme="outline"
          size="large"
          width="300"
          text="signin_with"
        />
        <div style={styles.note}>Only @ninjavan.co accounts are permitted.</div>
      </div>
    </div>
  );
}